import React from 'react';

const path = process.env.PUBLIC_URL

const Cover = () => {
  return(
    <section className="cover">
      <div className="title__wrapper">
        <div className="tag">Special Report</div>
        <h1 className="maintitle">Between Vision and Reality: the Gap in China’s Fight Against HIV</h1>
        <div className="content">
          <p>After “breaking up” with a large number of NGOs, the Chinese government took over the prevention, testing, and treatment of HIV, and formulated the <a target="_blank" rel="noreferrer noopener" href="http://www.gov.cn/zhengce/2016-10/25/content_5124174.htm" >“Healthy China 2030 Plan.”</a> But this has not changed the fact that the number of people with HIV in China has been rising year after year. In the face of this, individuals are faced with numerous difficulties.</p>
        </div>
      </div>
      <div className="image__wrapper">
        <img alt="" src={path + '/images/cover.png'} />
      </div>
    </section>
  )
}

export default Cover;